import { AdminView } from '@pages/admin-view/admin-view-routes.names';

export const Subscriptions = 'subscriptions';
export const Business = 'business';
export const BusinessSubscriptions = `/${AdminView}/${Business}/${Subscriptions}`;
